export default __webpack_public_path__ + "static/aviation-circle-52074f24843226578aedc913e1764791.png";